import Vue from 'vue'
import axios from 'axios'

function initialState() {
  return {
    files: { data: [], isLoading: false, totalLength: 0, offset: 0 },
    metadataSchemas: { data: [], isLoading: false },
    metadataStateLog: [],
  }
}
export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getFiles({ commit, state }, options) {
      if (options.forced != true && state.files.data.length > 0) {
        return
      }
      try {
        state.files.isLoading = true

        let data = options.data || {}
        options.config = options.config || { params: { limit: 5, offset: 0, sortBy: 'Name', descending: false } }
        let res = await axios.post('api/RawDataRepository/Files/Search', data, options.config)
        commit('AddFiles', res.data)
        options.successCb(res)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error))
      } finally {
        state.files.isLoading = false
      }
    },
    async getRecycledFiles({ commit, state }, options) {
      if (options.forced != true && state.files.data.length > 0) {
        return
      }
      try {
        state.files.isLoading = true

        let data = options.data || {}
        options.config = options.config || { params: { limit: 5, offset: 0, sortBy: 'Name', descending: false } }
        let res = await axios.post('api/RawDataRepository/Files/RecycleBin', data, options.config)
        commit('AddFiles', res.data)
        options.successCb(res)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error))
      } finally {
        state.files.isLoading = false
      }
    },
    async getFileById({ commit, state }, options) {
      if (!options.fileId) {
        options.failedCb()
      }
      try {
        let res = await axios.get(`api/RawDataRepository/File/${options.fileId}`)
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async downloadFileById({ commit }, { fileId }) {
      return axios.get(`api/RawDataRepository/file/${fileId}/download`)
        .then(response => response.data)
        .catch(error => { throw translateAPIErrorMessages(error) })
    },
    async addFile({ commit }, payload) {
      try {
        let res = await axios.post(
          'api/RawDataRepository/File',
          payload, { headers: { 'Content-Type': 'multipart/form-data' } },
        )
        return res.data
      } catch (error) {
        throw translateAPIErrorMessages(error)
      }
    },
    async putFile({ commit, state }, options) {
      try {
        let res = await axios.put(
          `api/RawDataRepository/File/${options.fileId}`,
          options.payload,
        )
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async getMetadataSchemas({ commit, state }, options) {
      /*if (options.forced != true && state.metadataSchemas.data.length > 0) {
        return
      }*/
      try {
        state.metadataSchemas.isLoading = true
        let res = await axios.get(
          'api/RawDataRepository/Metadata/Schemas',
        )
        commit('AddMetadataSchemas', res.data)
        options.successCb(res)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error))
      } finally {
        state.metadataSchemas.isLoading = false
      }
    },
    async addSchema({ commit }, options) {
      try {
        let res = await axios.post(
          'api/RawDataRepository/Metadata/Schema',
          options.payload
        )
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async putSchema({ commit, state }, options) {
      try {
        let res = await axios.put(
          `api/RawDataRepository/Metadata/Schema/${options.schemaId}`,
          options.payload,
        )
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async deleteSchema({ commit, state }, options) {
      try {
        let res = await axios.delete(
          `api/RawDataRepository/Metadata/Schema/${options.schemaId}/${options.isTestRun}`,          
        )
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async getUploadIdentifier({ commit }, options) {
      try {
        let res = await axios.get('api/RawDataRepository/UpoadFileIdentifier')
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async deleteFile({ commit, state }, options) {
      try {
        let res = await axios.delete(
          `api/RawDataRepository/File/${options.fileId}/Delete`,
          options.payload,
        )
        return res.data
        //options.successCb(res.data)
      } catch (error) {
        throw error
        //options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
    async restoreFile({ commit, state }, options) {
      try {
        let res = await axios.post(
          `api/RawDataRepository/File/${options.fileId}/Restore`,
          options.payload,
        )
        return res.data
        //options.successCb(res.data)
      } catch (error) {
        throw error
        //options.failedCb(translateAPIErrorMessages(error), error)
      }
    },
  },
  mutations: {
    AddFiles(state, response) {
      Vue.set(state.files, 'data', response.Data)
      Vue.set(state.files, 'totalLength', response.TotalLength)
      Vue.set(state.files, 'offset', response.Offset)
    },
    AddMetadataSchemas(state, data) {
      state.metadataSchemas.data = data
    },
    AppendLogEntry(state, request) {
      Vue.set(state.metadataStateLog, state.metadataStateLog.length, request)
    },
  },
  getters: {
    files: state => state.files,
    fileById: state => (id) => state.files.data.filter((f) => f.Id == id),
    metadataSchemas: state => state.metadataSchemas,
    metadataSchemaById: state => (id) => state.metadataSchemas.data.filter(schema => schema.Id == id),
    metadataSchemaByName: state => (name) => state.metadataSchemas.data.find(schema => schema.Name == name),
    metadataStateLog: state => state.metadataStateLog,
  },
}

function translateAPIErrorMessages(error) {
  if (!(error && error.response)) {
    return error.message
  }
  if (error.response.status == 401) {
    return 'Authentication error, please check user permissions or log in again'
  }
  if (error.response.status == 400) {
    return (error.response.data || error.response.data.ExceptionMessage) ? error.response.data.ExceptionMessage : error.message
  }
  return error.response.data
}